import React, { useEffect } from 'react'
import { Paper } from '@material-ui/core'
import ActionBar from 'components/ActionBar'
import Tooltip from '@material-ui/core/Tooltip'
import { useHistory, useLocation } from 'react-router-dom'
import ViewHeader from 'components/ViewHeader'
import { useDispatch, useSelector } from 'react-redux'
import ResourceNotFound from 'components/ResourceNotFound'
import Loading from 'components/Loading'
import { EditOutlined as EditIcon, DeleteOutlineOutlined as DeleteIcon } from '@material-ui/icons'
import { useConfirm } from 'material-ui-confirm'
import getTableOptions from 'utils/getTableOptions'
import sponsorSlice, { deleteSponsorById, getSponsors } from 'store/sponsor'
import BasicTable from 'components/BasicTable'
import { renderCol } from 'utils/renderColumns'

import { caseInsensitiveSort } from 'utils'

const SponsorListing = () => {
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const history = useHistory()
  const location = useLocation()
  const { user } = useSelector((state) => state.auth)
  const { sponsors, currentPage, pageSize, inProgress } = useSelector((state) => state.sponsor)

  useEffect(() => {
    const unsub = getSponsors(user?.conferenceId, (data) => {
      dispatch(sponsorSlice.actions.setSponsors(caseInsensitiveSort(data, 'fullName')))
    })
    return () => unsub && unsub()
  }, [dispatch, user?.conferenceId])

  const tableHead = [
    'Company',
    'Email',
    'Booth No',
    'Website',
    {
      name: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => renderCol(value),
        customHeadLabelRender: (meta) => renderCol(meta.label)
      }
    }
  ]
  const formatTableData = (sponsors) =>
    sponsors.map((sponsor) => [
      sponsor.fullName,
      sponsor.email,
      sponsor?.booth ? sponsor?.booth : 'N/A',
      sponsor.websiteUrl,
      <>
        <Tooltip title="Edit">
          <EditIcon
            color="action"
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`${location.pathname}/edit/${sponsor.id}`)}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <DeleteIcon
            color="action"
            style={{ marginLeft: 5, cursor: 'pointer' }}
            onClick={async () => {
              try {
                await confirm({
                  title: 'Delete Sponsor',
                  description: 'Are you sure you want to delete this Sponsor ?'
                })
                await dispatch(deleteSponsorById(user?.conferenceId, sponsor.id))
              } catch {
                // do nothing
              }
            }}
          />
        </Tooltip>
      </>
    ])

  const options = getTableOptions()

  return (
    <>
      <ViewHeader title="Sponsors">
        {inProgress && <Loading />}
        <ActionBar
          actionText="New Sponsor"
          onAction={() => history.push(`${location.pathname}/new`)}
          searchPlaceholder="Search Events"
        />
      </ViewHeader>

      {sponsors && sponsors.length ? (
        <Paper variant="outlined" style={{ marginTop: 20 }}>
          <BasicTable
            data={formatTableData(sponsors)}
            columns={tableHead}
            options={{
              ...options,
              onChangePage: (page) => dispatch(sponsorSlice.actions.setCurrentPage(page)),
              onChangeRowsPerPage: (size) => dispatch(sponsorSlice.actions.setPageSize(size)),
              page: currentPage,
              rowsPerPage: pageSize
            }}
          />
        </Paper>
      ) : (
        !inProgress && <ResourceNotFound message="No sponsor available" />
      )}
    </>
  )
}

export default SponsorListing
